import type { OnCardInteract } from '@apps/admin/suggestions/components/SuggestionCard';
import chroma from 'chroma-js';

export const deriveNextCardStateFromInteraction = (args: Parameters<OnCardInteract>[0]) => {
  const { interaction, stateJSON } = args;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const nextStateJson = { ...stateJSON } as any;
  const nowTimestamp = new Date().toISOString();

  const unsetOrIgnoreStateKey = (stateKey: 'usedAt' | 'snoozedAt' | 'declinedAt') => {
    if (nextStateJson[stateKey] !== undefined) {
      nextStateJson[stateKey] = null;
    }
  };

  let interactionStateKey: 'usedAt' | 'snoozedAt' | 'declinedAt';
  let shouldUnsetUsedAt: boolean = false;
  let shouldUnsetSnoozedAt: boolean = false;
  let shouldUnsetDeclinedAt: boolean = false;

  if (interaction === 'use') {
    interactionStateKey = 'usedAt';
    shouldUnsetSnoozedAt = true;
    shouldUnsetDeclinedAt = true;
  } else if (interaction === 'snooze') {
    interactionStateKey = 'snoozedAt';
    shouldUnsetUsedAt = true;
    shouldUnsetDeclinedAt = true;
  } else {
    interactionStateKey = 'declinedAt';
    shouldUnsetUsedAt = true;
    shouldUnsetSnoozedAt = true;
  }

  if (shouldUnsetUsedAt) {
    unsetOrIgnoreStateKey('usedAt');
  }
  if (shouldUnsetSnoozedAt) {
    unsetOrIgnoreStateKey('snoozedAt');
  }
  if (shouldUnsetDeclinedAt) {
    unsetOrIgnoreStateKey('declinedAt');
  }
  nextStateJson[interactionStateKey] = nowTimestamp;

  return nextStateJson;
};

///////////////

const TWO_HOURS = 60 * 60 * 1000 * 2;
export const shouldShowPreviewFirst = (creationDate: Maybe<number>) => {
  if (creationDate && Date.now() - creationDate < TWO_HOURS) {
    return true;
  }

  return false;
};

///////////////

export type ColorRGBA = [r: number, g: number, b: number, a: number];
export type Color = ColorRGBA | string;

const transformToChromaColor = (color: Color): chroma.Color => {
  const input = typeof color === 'string' ? color : `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${color[3]})`;
  return chroma(input);
};

export const colorToCss = (color: Color): string => {
  return transformToChromaColor(color).css();
};
